import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';
import {
  CHARGE_STATUS,
  ORDER_STATUS,
  ChargeStatusValidationEnum,
  OrderStatusValidationEnum,
  ChargeAbandonmentStatusValidationEnum,
} from '../charge/enum';

export const PaymentListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description:
        'Search payments by customerEmail, customerName, productTitle, or orderId. Contains match.',
    }),
    status: ChargeStatusValidationEnum.optional().meta({
      description: `Payment status filter. Valid values: ${Object.values(CHARGE_STATUS).join(', ')}.`,
    }),
    orderStatus: OrderStatusValidationEnum.optional().meta({
      description: `Order lifecycle status filter. Valid values: ${Object.values(ORDER_STATUS).join(', ')}.`,
    }),
    pageId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter payments by page ID.',
    }),
    customerId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter payments by customer ID.',
    }),
    orderId: z.string().optional().meta({ description: 'Filter by exact order ID.' }),
    couponCode: z.string().optional().meta({
      description: "Filter payments where a specific coupon code was used (e.g. 'SUMMER20').",
    }),
    productId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter payments by product ID.',
    }),
    createdAfter: z.iso.datetime().optional().meta({
      description: 'Filter by lower bound of createdAt.',
    }),
    createdBefore: z.iso.datetime().optional().meta({
      description: 'Filter by upper bound of createdAt.',
    }),
    abandonmentStatus: ChargeAbandonmentStatusValidationEnum.optional().meta({
      description: 'Filter by `abandoned` or `recovered` payments.',
    }),
    livemode: LivemodeFilterValidationSchema,
  }).refine(
    data =>
      !(
        data.createdAfter &&
        data.createdBefore &&
        Date.parse(data.createdAfter) > Date.parse(data.createdBefore)
      ),
    {
      message: 'createdAfter must be earlier than or equal to createdBefore',
      path: ['createdBefore'],
    },
  ),
);
